import React from 'react';
import { Helmet } from 'react-helmet';
import {
  FLIGHT_SEARCH_TYPE,
  SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS,
} from '../../utils/constants';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import withResults from '../../utils/hocComponent';
import BrowseResults from '../../components/BrowseResults';
import { shouldSearchReturnResultsVar } from '../../operations/localState/reactiveVariables';
import { getSessionStorageItem } from '../../operations/sessionStorage/utils';
import setSearchResults from '../../operations/localState/setSearchResults';

const BrowseReturnFlights = withResults(BrowseResults, FLIGHT_SEARCH_TYPE.RETURN);

const BrowseResultsReturn = () => {
  const getDictionary = useDictionary(Dictionary);

  if (!shouldSearchReturnResultsVar()) {
    const lastDepartureFlightResults = getSessionStorageItem(
      SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS,
    );
    if (lastDepartureFlightResults && lastDepartureFlightResults.matchingFlights) {
      setSearchResults(lastDepartureFlightResults);
    }
  }

  return (
    <>
      <Helmet>
        <title>{getDictionary(Dictionary.airBrowseResultsReturnSeoTitle.key)}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <BrowseReturnFlights />;
    </>
  );
};

export default BrowseResultsReturn;
